import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetTransportAreaPostplacesAddParams, TransportAreaPostplacesGet, TransportAreaService } from '@app/services/transport-area.service';

@Component({
    selector: 'tt-transport-area-pp-add',
    templateUrl: './transport-area-pp-add.component.html',
    styleUrls: ['./transport-area-pp-add.component.css'],
    standalone: false,
})
export class TransportAreaPpAddComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetTransportAreaPostplacesAddParams;

    public page?: TransportAreaPostplacesGet;

    public saving = false;

    constructor(
        private modal: ModalService,
        private transportArea: TransportAreaService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async save() {
        if (!!this.page) {
            try {
                this.saving = true;

                const { errorcode, errormessage } = await this.transportArea.addTransportAreaPostplaces(this.page);

                if ('' + errorcode !== '0') {
                    this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
                } else {
                    this.navigator?.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async loadPage() {
        if (!!this.params) {
            this.page = await this.transportArea.getTransportAreaPostplacesAdd(this.params);
        }
    }

    private async init() {
        this.loadPage();
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '60rem' });
            this.navigator.setHeading?.('p2_m_transportareappadd', true);
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('transportAreaPpAdd', {
//        templateUrl: 'views/components/views/transportAreaPpAdd/transportAreaPpAdd.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'transportAreaPpAddService', function ($stateParams, stateService, modalService, translateService, transportAreaPpAddService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let transportAreaKeyno = $stateParams.transportarea_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await transportAreaPpAddService.getEdit({ transportarea_keyno: transportAreaKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                transportAreaPpAddService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
